import React from 'react';
import { Card } from 'react-bootstrap';
import { Line } from 'react-chartjs-2';
import { chartJsDefaultTooltip } from './chartjs-utils';
import PropTypes from 'prop-types';
import chartTrendline from 'chartjs-plugin-trendline';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  chartTrendline
);

const TREND_LINE_LEGEND_TEXT = 'Trend Line';
const TREND_LINE_LEGEND_COLOR = 'rgba(255,26,104, 1)';

const generateLegendLabelsWithManualTrendLineEntry = chart => {
  const datasetLegendItems = ChartJS.defaults.plugins.legend.labels.generateLabels(chart);
  return [
    ...datasetLegendItems,
    {
      text: TREND_LINE_LEGEND_TEXT,
      strokeStyle: TREND_LINE_LEGEND_COLOR,
      fillStyle: 'transparent',
      lineWidth: 1,
      lineDash: [4, 2]
    }
  ];
};

const toggleDatasetVisibilityOnLegendClick = (event, legendItem, legend) => {
  const { datasetIndex } = legendItem;
  const clickedEntryHasNoDataset = datasetIndex === undefined || datasetIndex === null;
  if (clickedEntryHasNoDataset) return;

  const chart = legend.chart;
  if (chart.isDatasetVisible(datasetIndex)) {
    chart.hide(datasetIndex);
    legendItem.hidden = true;
  } else {
    chart.show(datasetIndex);
    legendItem.hidden = false;
  }
};

export const SingleLineChart = ({
  title,
  labels,
  dataset,
  borderColor,
  borderWidth,
  width,
  height,
  legendLabel
}) => {
  const data = {
    labels,
    datasets: [
      {
        label: legendLabel,
        borderColor: borderColor,
        borderWidth: borderWidth,
        backgroundColor: '#0275d8',
        data: dataset,
        trendlineLinear: {
          colorMin: 'rgba(255,26,104, 0.5)',
          colorMax: 'rgba(255,26,104, 0.5)',
          lineStyle: 'dashed',
          width: 2,
          projection: true,
          label: {
            color: TREND_LINE_LEGEND_COLOR,
            text: TREND_LINE_LEGEND_TEXT,
            display: false,
            displayValue: true,
            percentage: true
          },
          legend: { display: false }
        }
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: chartJsDefaultTooltip(borderColor),
      legend: {
        labels: { generateLabels: generateLegendLabelsWithManualTrendLineEntry },
        onClick: toggleDatasetVisibilityOnLegendClick
      }
    }
  };

  return (
    <Card style={{ width: width, height: height }}>
      <Card.Header>
        <h4 style={{ textAlign: 'center' }}>{title}</h4>
      </Card.Header>
      <Card.Body>
        <Line data={data} options={options} height={'100%'} width={'100%'} />
      </Card.Body>
    </Card>
  );
};

SingleLineChart.propTypes = {
  title: PropTypes.string,
  labels: PropTypes.array,
  dataset: PropTypes.array,
  width: PropTypes.number,
  height: PropTypes.number,
  borderColor: PropTypes.string,
  borderWidth: PropTypes.number,
  legendLabel: PropTypes.string
};
